import { ICreateDishContext } from './createDishContext';

export enum CreateDishActionTypes {
	SET_FILE_ID = 'SET_FILE_ID',
	CHANGE_NAME_OF_DISH = 'CHANGE_NAME_OF_DISH',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	TOGGLE_HAS_SCHEDULE_PRIORITY = 'TOGGLE_HAS_SCHEDULE_PRIORITY',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_SUGGESTED_DISH_CATEGORY = 'SET_SUGGESTED_DISH_CATEGORY',
	SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES = 'SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES',
	SET_SUGGESTED_DISH_SUB_CATEGORY = 'SET_SUGGESTED_DISH_SUB_CATEGORY',
	SET_FETCHED_SUGGESTED_DISHES = 'SET_FETCHED_SUGGESTED_DISHES',
	SET_SUGGESTED_DISHES = 'SET_SUGGESTED_DISHES',
	REMOVE_SUGGESTED_DISH = 'REMOVE_SUGGESTED_DISH',
	SET_ADDITIONAL_DISH_CATEGORY = 'SET_ADDITIONAL_DISH_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES = 'SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES',
	SET_ADDITIONAL_DISH_SUB_CATEGORY = 'SET_ADDITIONAL_DISH_SUB_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISHES = 'SET_FETCHED_ADDITIONAL_DISHES',
	SET_ADDITIONAL_DISHES = 'SET_ADDITIONAL_DISHES',
	REMOVE_ADDITIONAL_DISH = 'REMOVE_ADDITIONAL_DISH',
	SET_MODIFICATION_DISH_CATEGORY = 'SET_MODIFICATION_DISH_CATEGORY',
	SET_FETCHED_MODIFICATION_DISH_SUB_CATEGORIES = 'SET_FETCHED_MODIFICATION_DISH_SUB_CATEGORIES',
	SET_MODIFICATION_DISH_SUB_CATEGORY = 'SET_MODIFICATION_DISH_SUB_CATEGORY',
	SET_FETCHED_MODIFICATION_DISHES = 'SET_FETCHED_MODIFICATION_DISHES',
	SET_MODIFICATION_DISHES = 'SET_MODIFICATION_DISHES',
	REMOVE_MODIFICATION_DISH = 'REMOVE_MODIFICATION_DISH',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetFileId {
	type: CreateDishActionTypes.SET_FILE_ID;
	payload: {
		fileId: ICreateDishContext['fileId'];
	};
}

interface IChangeNameOfDish {
	type: CreateDishActionTypes.CHANGE_NAME_OF_DISH;
	payload: {
		nameOfDish: ICreateDishContext['nameOfDish'];
	};
}

interface IChangeDescription {
	type: CreateDishActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: ICreateDishContext['description'];
	};
}

interface ISetFetchedCustomers {
	type: CreateDishActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: ICreateDishContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: CreateDishActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICreateDishContext['IDSelectedCustomer'];
	};
}

interface IChangeExternalId {
	type: CreateDishActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: ICreateDishContext['externalId'];
	};
}

interface ISetFetchedTranslation {
	type: CreateDishActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: ICreateDishContext['translations'];
		defaultCustomerLanguage: ICreateDishContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: CreateDishActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: ICreateDishContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: CreateDishActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: ICreateDishContext['translations'];
	};
}

interface IToggleHasSchedulePriority {
	type: CreateDishActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY;
}

interface IChangeActivationSchedule {
	type: CreateDishActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: ICreateDishContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: CreateDishActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: ICreateDishContext['deactivationSchedule'];
	};
}

interface ISetFetchedRestaurants {
	type: CreateDishActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: ICreateDishContext['fetchedRestaurants'];
	};
}

interface ISetIDsRestaurant {
	type: CreateDishActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: ICreateDishContext['IDsSelectedRestaurant'];
	};
}

interface ISetFetchedCategories {
	type: CreateDishActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		fetchedCategories: ICreateDishContext['fetchedCategories'];
	};
}

interface ISetSuggestedDishCategory {
	type: CreateDishActionTypes.SET_SUGGESTED_DISH_CATEGORY;
	payload: {
		selectedSuggestedDishCategory: ICreateDishContext['selectedSuggestedDishCategory'];
	};
}

interface ISetFetchedSuggestedDishSubCategories {
	type: CreateDishActionTypes.SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES;
	payload: {
		fetchedSuggestedDishSubCategories: ICreateDishContext['fetchedSuggestedDishSubCategories'];
	};
}

interface ISetSuggestedDishSubCategory {
	type: CreateDishActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY;
	payload: {
		selectedSuggestedDishSubCategory: ICreateDishContext['selectedSuggestedDishSubCategory'];
	};
}

interface ISetFetchedSuggestedDishes {
	type: CreateDishActionTypes.SET_FETCHED_SUGGESTED_DISHES;
	payload: {
		fetchedSuggestedDishes: ICreateDishContext['fetchedSuggestedDishes'];
	};
}

interface ISetSuggestedDishes {
	type: CreateDishActionTypes.SET_SUGGESTED_DISHES;
	payload: {
		selectedSuggestedDishes: ICreateDishContext['selectedSuggestedDishes'];
	};
}

interface ISetAdditionalDishCategory {
	type: CreateDishActionTypes.SET_ADDITIONAL_DISH_CATEGORY;
	payload: {
		selectedAdditionalDishCategory: ICreateDishContext['selectedAdditionalDishCategory'];
	};
}

interface ISetFetchedAdditionalDishSubCategories {
	type: CreateDishActionTypes.SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES;
	payload: {
		fetchedAdditionalDishSubCategories: ICreateDishContext['fetchedAdditionalDishSubCategories'];
	};
}

interface ISetAdditionalDishSubCategory {
	type: CreateDishActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY;
	payload: {
		selectedAdditionalDishSubCategory: ICreateDishContext['selectedAdditionalDishSubCategory'];
	};
}

interface ISetFetchedAdditionalDishes {
	type: CreateDishActionTypes.SET_FETCHED_ADDITIONAL_DISHES;
	payload: {
		fetchedAdditionalDishes: ICreateDishContext['fetchedAdditionalDishes'];
	};
}

interface ISetAdditionalDishes {
	type: CreateDishActionTypes.SET_ADDITIONAL_DISHES;
	payload: {
		selectedAdditionalDishes: ICreateDishContext['selectedAdditionalDishes'];
	};
}

interface ISetModificationDishCategory {
	type: CreateDishActionTypes.SET_MODIFICATION_DISH_CATEGORY;
	payload: {
		selectedModificationDishCategory: ICreateDishContext['selectedModificationDishCategory'];
	};
}

interface ISetFetchedModificationDishSubCategories {
	type: CreateDishActionTypes.SET_FETCHED_MODIFICATION_DISH_SUB_CATEGORIES;
	payload: {
		fetchedModificationDishSubCategories: ICreateDishContext['fetchedModificationDishSubCategories'];
	};
}

interface ISetModificationDishSubCategory {
	type: CreateDishActionTypes.SET_MODIFICATION_DISH_SUB_CATEGORY;
	payload: {
		selectedModificationDishSubCategory: ICreateDishContext['selectedModificationDishSubCategory'];
	};
}

interface ISetFetchedModificationDishes {
	type: CreateDishActionTypes.SET_FETCHED_MODIFICATION_DISHES;
	payload: {
		fetchedModificationDishes: ICreateDishContext['fetchedModificationDishes'];
	};
}

interface ISetModificationDishes {
	type: CreateDishActionTypes.SET_MODIFICATION_DISHES;
	payload: {
		selectedModificationDishes: ICreateDishContext['selectedModificationDishes'];
	};
}

interface ISetDataForSubmit {
	type: CreateDishActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateDishContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateDishContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: CreateDishActionTypes.RESET_FIELDS;
}

export type TCreateDishAction =
	| ISetFileId
	| IChangeNameOfDish
	| IChangeDescription
	| ISetFetchedCustomers
	| ISetIDCustomer
	| IChangeExternalId
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| IToggleHasSchedulePriority
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| ISetFetchedCategories
	| ISetSuggestedDishCategory
	| ISetFetchedSuggestedDishSubCategories
	| ISetSuggestedDishSubCategory
	| ISetFetchedSuggestedDishes
	| ISetSuggestedDishes
	| ISetAdditionalDishCategory
	| ISetFetchedAdditionalDishSubCategories
	| ISetAdditionalDishSubCategory
	| ISetFetchedAdditionalDishes
	| ISetAdditionalDishes
	| ISetModificationDishCategory
	| ISetFetchedModificationDishSubCategories
	| ISetModificationDishSubCategory
	| ISetFetchedModificationDishes
	| ISetModificationDishes
	| IResetSelectedControls
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
